class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          this.initSlideshowSlick();

        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);


  }

  initSlideshowSlick(){
    const slideshow = this.querySelector('.slideshow');

    $(slideshow).slick({
      dots: this.dataset.dots == 'true' ? true : false,
      arrows: this.dataset.arrows == 'true' ? true : false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      autoplaySpeed: this.dataset.speed,
      responsive: [
       {
         breakpoint: 1190,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 2
         }
       },
       {
         breakpoint: 576,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1
         }
       }
     ]
    });

    const prev = slideshow.querySelector('.slick-prev');
    const next = slideshow.querySelector('.slick-next');

    $(prev).hide();

    $(slideshow).on('afterChange', function(event, slick, currentSlide) {
        if (currentSlide === 0) {
          $(prev).fadeOut('fast');
          $(next).fadeIn('fast');
        }
        else {
        	$(prev).fadeIn('fast');
        }

        if ($(slick.$slides[slick.$slides.length - 3]).hasClass('slick-current')) {
        	$(next).fadeOut('fast');
        } else {
          $(next).fadeIn('fast');
        }
      });

  }

}

customElements.define('product-recommendations', ProductRecommendations);
